import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="radio-options"
export default class extends Controller {
  static values = {
    // The 'name' attribute of the radio button group this controller manages
    radioName: String,
  };

  connect() {
    // Find all elements within the controller's scope that are conditionally shown
    // These elements are identified by the 'data-show-when-value' attribute
    this.conditionalElements = Array.from(
      this.element.querySelectorAll("[data-show-when-value]")
    );

    if (!this.radioNameValue) {
      console.error(
        "RadioOptionsController: 'radioNameValue' is not defined for this controller instance.",
        this.element
      );
      return;
    }

    // Find all radio buttons within the controller's scope that belong to the specified group
    this.radioButtons = Array.from(
      this.element.querySelectorAll(
        `input[type="radio"][name="${this.radioNameValue}"]`
      )
    );

    if (this.radioButtons.length === 0) {
      console.warn(
        `RadioOptionsController: No radio buttons found with name "${this.radioNameValue}".`,
        this.element
      );
    }

    // Set the initial visibility of conditional elements based on the current radio selection
    this.processVisibility();
  }

  // This method is triggered by the data-action on the radio buttons
  update() {
    this.processVisibility();
  }

  processVisibility() {
    const selectedRadio = this.radioButtons.find((radio) => radio.checked);
    const selectedValue = selectedRadio ? selectedRadio.value : null;

    this.conditionalElements.forEach((element) => {
      const showWhenValueAttr = element.dataset.showWhenValue;
      let showForValues;

      try {
        // Attempt to parse the attribute as a JSON array (for multiple trigger values)
        const parsed = JSON.parse(showWhenValueAttr);
        showForValues = Array.isArray(parsed) ? parsed : [String(parsed)];
      } catch (e) {
        // If parsing fails, treat it as a single string value
        showForValues = [showWhenValueAttr];
      }

      // Show the element if its 'data-show-when-value' matches the selected radio button's value
      if (selectedValue && showForValues.includes(selectedValue)) {
        element.style.display = "block";
      } else {
        element.style.display = "none";
      }
    });
  }
}
